module.exports = __webpack_public_path__ + "static/media/icon-audio.123daace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/icon-audio.svg
// module id = 404
// module chunks = 0